const mapping = {};
const requireMapping = require.context("@/mapping", true, /\.js$/);
requireMapping.keys().forEach((path) => {
  const name = path.replace(/^\.\/(.*)\.js+$/, "$1");
  if (name == "index" || name == "common") {
    return;
  }
  const m = requireMapping(path);
  mapping[name] = m.default;
});

export default mapping;